import { ref, computed } from 'vue';
import { defineStore } from "pinia";

export const useWarningOverlay = defineStore("warningOverlay", () => {
  const is_visible_ = ref<boolean>(false);
  const text_ = ref<string | null>(null);

  const is_visible = computed(() => is_visible_.value);
  const text = computed((): string | null => text_.value);
  function set_text(the_text: string) { text_.value = the_text; }

  function show() {
    console.log("[warning-overlay]: showing warning overlay");
    is_visible_.value = true;
  }

  function hide() {
    console.log("[warning-overlay]: hiding warning overlay");
    is_visible_.value = false;
    text_.value = null;
  }


  return { is_visible, text, show, hide, set_text };
});
